var BufferFormatter = require('bufferformatter');
var Message = require('message');
var Overlay = require('overlay');
var Whois = require('whois');
var sko = require('../../lib/safekeyobject.es6').default;
var twitch = require('../../lib/twitch.es6');
var utils = require('../../lib/util.es6');


var BufferOverlayHandler = Backbone.View.extend({
    initialize: function (options) {
        this.bindMessageHandlers();
        
        this.formatter = new BufferFormatter(this.model);
        this.model.on('remove', this.remove, this);
    },
    bindMessageHandlers: function () {
        var lastMesage = this.model.getLastMessage();
        this.max_rendered = lastMesage && lastMesage.id || 0;
        for (var type in this.messages) {
            this.model.bind('message:' + type, this.handleMessage, this);
        }
        this.model.bind('twitchRoomsOverlay', this.twitchRooms, this);
    },
    twitchRooms: function (rooms) {
        var displayName = this.model.getDisplayName();
        var title;
        var twitchInfo = this.model.getTwitchInfo();
        if (twitchInfo && twitchInfo.channel.display_name) {
            title = this.formatter.escapeText(twitchInfo.channel.display_name);
        } else {
            title = this.formatter.render(displayName);
        }
        var headers;
        if (rooms.length) {
            headers = [{
                title: 'Name',
                format: _.bind(function (data) {
                    return this.formatter.linkChannel(
                        twitch.roomChannel(data.owner_id, data._id),
                        {name: data.name}
                    );
                }, this)
            }, {
                title: 'Topic',
                name: 'topic'
            }, {
                title: 'Type',
                format: _.bind(function (data) {
                    return this.formatter.escapeText(twitch.roomType(data));
                }, this)
            }];
        }
        var overlay = new Overlay(this.buildTable(
            {type: 'twitchRooms'},
            'Twitch rooms for ' + title,
            rooms,
            headers,
            title + ' hasn’t created any rooms yet'
        ));
        this.triggerAdd(overlay);
    },
    isMessageIgnored: function (message) {
        if (!Message.isIgnorable(message.type)) {
            return false;
        }
        return this.model.connection.isIgnored(message.from || message.nick, message.hostmask);
    },
    handleMessage: function (message) {
        if (!message.eid || message.eid < 0 || message.eid > this.max_rendered) {
            if (this.isMessageIgnored(message)) {
                return;
            }
            var overlay = this.messages[message.type].call(this, message);
            if (overlay) {
                overlay.message = message;
                this.triggerAdd(overlay);
                if (message.eid > 0) {
                    this.max_rendered = message.eid;
                }
            }
        }
    },
    triggerAdd: function (overlay) {
        this.trigger('addOverlay', overlay);
    },
    appendWhoisChannels: function (content, whois, priv) {
        var memberTypes = [{
            key: 'oper',
            title: 'Oper in'
        }, {
            key: 'owner',
            title: 'Owner of'
        }, {
            key: 'admin',
            title: 'Admin in'
        }, {
            key: 'op',
            title: 'Operator in'
        }, {
            key: 'halfop',
            title: 'Halfop in'
        }, {
            key: 'voiced',
            title: 'Voiced in'
        }, {
            key: 'member',
            title: 'Member of'
        }];
        _.each(memberTypes, function (type, i) {
            var channels = whois.getChannels(type.key, priv);
            if (channels && channels.length) {
                content.append($('<p>').text(type.title + ':'));
                var opList = $('<ul>');
                _.each(channels, function (chan, j) {
                    var html = this.formatter.linkChannel(chan.channel);
                    if (chan.prefix) {
                        html += ' <b>' + this.formatter.escapeText(chan.prefix) + '</b>';
                    }
                    opList.append($("<li>").html(html));
                }, this);
                content.append(opList);
            }
        }, this);
    },
    buildTable: function (message, title, data, headers, noDataMessage) {
        var content = $('<div>');
        // Heading
        if (title) {
            var heading = $('<div class="heading">');
            var headingTitle = $('<h2>').html(title);
            heading.append(headingTitle);
            content.append(heading);
        }
        
        // Table
        if (data && data.length) {
            var table = $('<table cellspacing="0" class="overlayTable">');
            var headRow = $('<tr>');
            _.each(headers, function (header, i) {
                var className = 'data_' + message.type;
                if (header.name) {
                    className += '_' + header.name;
                }
                header.className = className;
                headRow.append($('<th>').html(header.title).addClass(header.className));
            }, this);
            var body = $('<tbody>');
            _.each(data, function (item, i) {
                var className = i % 2 ? 'even' : 'odd';
                var dataRow = $('<tr>').addClass(className);
                if (headers) {
                    _.each(headers, function (header, headerI) {
                        var value = false;
                        if (header.format) {
                            // Format function
                            value = header.format(item);
                        } else if (typeof item[header.name] == "boolean") {
                            // Format bool
                            value = '<i class="fa fa-' + (item[header.name] ? 'check' : 'times') + '" title="' + (item[header.name] ? 'Yes' : 'No') + '"></i>';
                        } else if (header.channel && item[header.channel] != '*' && header.channel in item) {
                            // Format channel link
                            value = this.formatter.linkChannel(item[header.channel]);
                        } else if (header.nick && header.nick in item) {
                            // Format nick link
                            value = this.formatter.linkNick(item[header.nick]);
                        } else if (header.mask && header.mask in item) {
                            // Format mask
                            value = this.formatter.renderNoEmoji(item[header.mask]);
                        } else if (header.link && header.link in item) {
                            // Format link
                            value = this.formatter.linkBuffer(item[header.link]);
                        } else if (header.name in item) {
                            // Format anything else
                            value = this.formatter.render(item[header.name]);
                        }
                        if (value !== false) {
                            dataRow.append($('<td>').html(value).addClass(header.className));
                        }
                    }, this);
                } else {
                    var iterator;
                    if (_.isObject(item)) {
                        iterator = item;
                    } else {
                        iterator = $.makeArray(item);
                    }
                    _.each(iterator, function (itemValue) {
                        var value = this.formatter.renderLinkify(itemValue);
                        var className = 'data_' + message.type;
                        dataRow.append($('<td>').html(value).addClass(className));
                    }, this);
                }
                body.append(dataRow);
            }, this);
            table.append($('<thead>').append(headRow))
                .append(body);
            content.append(table);
        } else {
            noDataMessage = noDataMessage || 'No data';
            content.append($('<p class="noData">').html(noDataMessage));
        }
        return content;
    },
    buildIsupportTable: function (params) {
        var table = $('<table cellspacing="0">');
        var body = $('<tbody>');
        var value;
        var objectTable, objectK;
        for (var k in params) {
            switch (typeof params[k]) {
            case "boolean":
                // Format bool
                value = '<i class="fa fa-' + (params[k] ? 'check' : 'times') + '" title="' + (params[k] ? 'Yes' : 'No') + '"></i>';
                break;
            case "string":
                value = this.formatter.escapeText(params[k]);
                break;
            default:
                if ($.isPlainObject(params[k])) {
                    objectTable = $('<table>');
                    for (objectK in params[k]) {
                        objectTable.append(
                            $('<tr>')
                                .append($('<th class="data_isupport_object_key">').text(objectK))
                                .append($('<td>').text(params[k][objectK]))
                        );
                    }
                    value = objectTable;
                } else {
                    value = this.formatter.escapeText(JSON.stringify(params[k]));
                }
            }
            body.append(
                $('<tr>')
                    .append($('<th class="data_isupport_key">').text(k))
                    .append($('<td>').html(value))
            );
        }
        table.append(body);
        return table;
    },
    simple: function (message) {
        return new Overlay(this.formatter.render(message.msg), {
            doneText: 'Close',
        });
    },
    messages: {
        who_response: function (message) {
            var subject;
            if (message.subject == '*') {
                subject = this.formatter.linkConnection();
            } else {
                subject = this.formatter.linkBuffer(message.subject);
            }
            return new Overlay(this.buildTable(message, 'WHO response for ' + subject, message.users, [{
                format: _.bind(function (data) {
                    var className;
                    var title = data.nick;
                    if (data.away) {
                        title += ' (away)';
                        className = 'away';
                    }
                    return this.formatter.linkNick(data.nick, {
                        className: className,
                        title: title
                    });
                }, this),
                title: 'Nickname'
            }, {
                format: _.bind(function (data) {
                    return this.formatter.renderLinkify(data.realname);
                }, this),
                title: 'Real name'
            }, {
                mask: 'usermask',
                title: 'Usermask'
            }, {
                format: _.bind(function (data) {
                    var message = data.ircserver;
                    if (data.hopcount) {
                        message += ' (' + data.hopcount + ' hops)';
                    }
                    return this.formatter.render(message);
                }, this),
                title: 'Connected via'
            }]));
        },
        who_special_response: function (message) {
            var subject;
            if (message.subject == '*') {
                subject = this.formatter.linkConnection();
            } else {
                subject = this.formatter.linkBuffer(message.subject);
            }
            return new Overlay(this.buildTable(message, 'WHO response for ' + subject, message.users));
        },
        whowas_response: function (message) {
            var lines, headers, noDataMessage;
            if (message.lines[0].no_such_nick) {
                lines = [];
                noDataMessage = this.formatter.render(message.lines[0].no_such_nick);
            } else {
                lines = message.lines;
                headers = [{
                    title: 'Nick',
                    nick: 'nick'
                }, {
                    title: 'Usermask',
                    format: _.bind(function (data) {
                        if (data.user && data.host) {
                            return this.formatter.renderNoEmoji(data.user + '@' + data.host);
                        } else {
                            return '';
                        }
                    }, this)
                }, {
                    title: 'Real name',
                    name: 'realname'
                }, {
                    title: 'Last connected',
                    name: 'last_seen'
                }, {
                    title: 'Connected via',
                    name: 'ircserver'
                }];
                if (utils.hasKey(message.lines, 'user_logged_in_as')) {
                    headers.push({
                        title: 'Account',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.user_logged_in_as);
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'connecting_from')) {
                    headers.push({
                        title: 'Info',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.connecting_from);
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'real_host')) {
                    headers.push({
                        title: 'Real Host',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.real_host.replace('was connecting from ', ''));
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'actual_host')) {
                    headers.push({
                        title: 'Actual host',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.actual_host);
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'country')) {
                    headers.push({
                        title: 'Country',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.country.replace('was connecting from ', ''));
                        }, this)
                    });
                }
                if (utils.hasKey(message.lines, 'asn_msg')) {
                    headers.push({
                        title: 'ASN',
                        format: _.bind(function (data) {
                            return this.formatter.render(data.asn_msg.replace('was connecting from ', ''));
                        }, this)
                    });
                }
            }
            var table = this.buildTable(
                message, 'WHOWAS response for ' + this.formatter.linkBuffer(message.nick), lines, headers, noDataMessage
            );
            return new Overlay(table);
        },
        whois_response: function (message) {
            var whois = new Whois(message);
            var nick = whois.get('user_nick') || whois.get('nick');

            var content = $('<div class="whoisInfo irccolors">');

            // Name/real name hostmask
            var nameParts = [];
            if (whois.get('user_realname')) {
                nameParts.push(this.formatter.renderLinkify(whois.get('user_realname')));
            }
            var mask = whois.getHostMask();
            var nameParenParts = [];
            if (mask) {
                nameParenParts.push(this.formatter.renderNoEmoji(mask));
            }
            if (whois.get('actual_host')) {
                nameParenParts.push(this.formatter.renderNoEmoji(whois.get('actual_host')));
            }
            if (nameParenParts.length) {
                nameParts.push('(' + nameParenParts.join(' / ') + ')');
            }
            if (whois.get('user_logged_in_as')) {
                nameParts.push('is authed as ' + this.formatter.renderLinkify(whois.get('user_logged_in_as')));
            }
            if (nameParts.length) {
                var name = nameParts.join(' ');
                content.append($('<p>').html(name));
            }
            
            // Away
            var away = whois.get('away');
            if (away) {
                var awayMsg = 'Away';
                if (away.toLowerCase() != 'away') {
                    awayMsg += ': ' + away;
                }
                content.append($('<p>').html(this.formatter.render(awayMsg)));
            }

            // Signon/idle time
            if (whois.get('signon_time')) {
                var online = "Online " + this.formatter.howLong(whois.getSignonDate(), true);
                if (whois.get('idle_secs')) {
                    online += " (idle " + this.formatter.howLong(whois.getIdleTime(), true) + ")";
                }
                content.append($('<p>').html(online));
            }
            
            // Status
            if (whois.get('bot_msg')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('bot_msg'))));
            }
            if (whois.get('op_nick')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('op_msg'))));
            }
            if (whois.get('opername')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('opername_msg') + ' ' + whois.get('opername'))));
            }
            if (whois.get('userip')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('userip'))));
            }
            // Connected via
            if (whois.get('server_addr')) {
                var server = "is connected via " + this.formatter.render(whois.get('server_addr'));
                if (whois.get('server_extra')) {
                    server += " (" + this.formatter.renderLinkify(whois.get('server_extra')) + ")";
                }
                content.append($('<p>').html(this.formatter.render(nick) + ' ' + server));
            }
            // Connecting from
            if (whois.get('host')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('host'))));
            }

            // Channel lists
            this.appendWhoisChannels(content, whois);

            // Private/secret channels
            if (whois.get('private_channels')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('private_channels'))));
                this.appendWhoisChannels(content, whois, true);
            }
            
            // Secure
            if (whois.get('secure')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('secure'))));
            }
            // CGI:IRC
            if (whois.get('cgi')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('cgi'))));
            }

            // Country
            if (whois.get('country')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('country'))));
            }
            // ASN
            if (whois.get('asn_msg')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('asn_msg'))));
            }
            
            // Client cert
            if (whois.get('client_cert')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('client_cert'))));
            }

            // Available for help
            if (whois.get('help')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('help'))));
            }
            // Staff
            if (whois.get('staff')) {
                content.append($('<p>').html(this.formatter.render(nick + ' is staff: ' + whois.get('staff'))));
            }
            // Special
            if (whois.get('special')) {
                _.each(whois.get('special'), function (specialLine) {
                    content.append($('<p>').html(this.formatter.render(nick + ' ' + specialLine)));
                }, this);
            }
            // Modes
            if (whois.get('modes')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('modes'))));
            }
            // Callerid
            if (whois.get('callerid')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('callerid'))));
            }
            // Stats Dline
            if (whois.get('stats_dline')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('stats_dline'))));
            }
            // BTN metadata
            if (whois.get('btn_metadata')) {
                content.append($('<p>').html(this.formatter.render(nick) + ' ' + this.formatter.renderLinkify(whois.get('btn_metadata'))));
            }
            // Text
            if (whois.get('text')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('text'))));
            }
            // msg_only_reg
            if (whois.get('msg_only_reg')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('msg_only_reg'))));
            }
            // suspend
            if (whois.get('suspend')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('suspend'))));
            }
            // chanop
            if (whois.get('chanop')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('chanop'))));
            }
            // kill
            if (whois.get('kill')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('kill'))));
            }
            // helper
            if (whois.get('helper')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('helper'))));
            }
            // admin
            if (whois.get('admin')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('admin'))));
            }
            // codepage
            if (whois.get('codepage')) {
                content.append($('<p>').html(this.formatter.render(nick + ' ' + whois.get('codepage'))));
            }
            var head = "Whois " + this.formatter.linkNick(nick);
            return new Overlay(content, {
                head: head
            });
        },
        text: function (message) {
            return this.simple(message);
        },
        help: function (message) {
            return this.simple(message);
        },
        list_usage: function (message) {
            return this.simple(message);
        },
        stats: function (message) {
            var msg = '';
            if (message.parts) {
                msg += this.formatter.render(message.parts);
                if (message.msg) {
                    msg += ': ';
                }
            }
            if (message.msg) {
                msg += this.formatter.renderLinkify(message.msg);
            }
            return new Overlay(msg, {
                doneText: 'Close',
            });
        },
        ignore_list: function (message) {
            var currentIgnores = new sko();
            if (this.model.session.currentBuffer) {
                this.model.session.currentBuffer.messages.each(function (m) {
                    var ig = m.isIgnored({returnMap: true});
                    if (ig.match) {
                        _.each(ig.masks, function (mask) {
                            currentIgnores.incr(mask);
                        });
                    }
                }, this);
            }
            var table = this.buildTable(message, 'Ignore list for ' + this.formatter.render(this.model.connection.getFullLabel()), message.masks, [{
                format: _.bind(function (mask) {
                    var matches = '';
                    var currentIgnore;
                    if ((currentIgnore = currentIgnores.get(mask))) {
                        matches = ' <span class="explanation">(' + currentIgnore + ' ';
                        matches += this.formatter.pluralise(currentIgnore, 'message');
                        matches += ' matched)</span>';
                    }
                    return this.formatter.linker.make('x', {
                        href: "",
                        'class': 'unignore',
                        'title': 'Unignore ' + mask,
                        'data-mask': mask
                    }) + ' ' + this.formatter.renderNoEmoji(mask) + matches;
                }, this),
                title: 'Usermask'
            }], 'You’re not ignoring anyone at the moment. You can ignore people from a menu by clicking their nickname or by using <kbd>/ignore</kbd>');
            
            var overlay = new Overlay(table);
            
            table.on('click', 'a.unignore', _.bind(function (e) {
                e.preventDefault();
                var link = $(e.currentTarget);
                this.model.connection.unignore(link.attr('data-mask'), _.bind(function (response) {
                    if (response.success) {
                        var row = link.closest('td');
                        link.removeClass('unignore');
                        link.addClass('undounignore');
                        row.addClass('unignored');
                    }
                }, this));
            }, this));
            table.on('click', 'a.undounignore', _.bind(function (e) {
                e.preventDefault();
                var link = $(e.currentTarget);
                this.model.connection.ignore(link.attr('data-mask'), _.bind(function (response) {
                    if (response.success) {
                        var row = link.closest('td');
                        link.addClass('unignore');
                        link.removeClass('undounignore');
                        row.removeClass('unignored');
                    }
                }, this));
            }, this));
            
            return overlay;
        },
        monitor_list: function (message) {
            var table = this.buildTable(message, 'Monitor list for ' + this.formatter.render(this.model.connection.getFullLabel()), message.list, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Target'
            }], "You’re not monitoring anyone at the moment. You can monitor when people go on and offline by using <kbd>/monitor + <code>nick</code></kbd>");
            
            var overlay = new Overlay(table);
            return overlay;
        },
        a_list: function (message) {
            var table = this.buildTable(message, 'Protected list for ' + this.formatter.linkChannel(message.channel), message.list, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Nick'
            }], 'No protected channel members');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        reop_list: function (message) {
            var table = this.buildTable(message, 'Reop list for ' + this.formatter.linkChannel(message.channel), message.list, [{
                format: _.bind(function (mask) {
                    return this.formatter.renderNoEmoji(mask);
                }, this),
                title: 'Mask'
            }], 'Empty channel reop list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        quiet_list: function (message) {
            var table = this.buildTable(message, 'Quiet list for ' + this.formatter.linkChannel(message.channel), message.list, [{
                mask: 'quiet_mask',
                title: 'Quiet mask'
            }, {
                mask: 'usermask',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time && data.time > 0) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }], 'Empty quiet list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        exempt_chan_ops: function (message) {
            var table = this.buildTable(message, 'Channel exemptions for ' + this.formatter.linkChannel(message.channel), message.list, [{
                name: 'exemption',
                title: 'Exemption'
            }, {
                name: 'mode',
                title: 'Mode'
            }, {
                name: 'setter',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time && data.time > 0) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }], 'Empty channel exemptions list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        invited_list: function (message) {
            var table = this.buildTable(message, 'Pending channel invites', message.list, [{
                name: 'channel',
                title: 'Channel',
                channel: 'channel'
            }], 'You haven’t been invited to any channels');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        invite_list: function (message) {
            var table = this.buildTable(message, 'Invite list for ' + this.formatter.linkChannel(message.channel), message.list, [{
                mask: 'mask',
                title: 'Invite mask'
            }, {
                mask: 'usermask',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }], 'Empty invite list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        q_list: function (message) {
            var table = this.buildTable(message, 'Owner list for ' + this.formatter.linkChannel(message.channel), message.nicks, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Nick'
            }], 'No channel owners');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        ircops: function (message) {
            var content = $('<div>');
            var heading = $('<div class="heading">');
            var headingTitle = $('<h2>').text('IRCOPS');
            heading.append(headingTitle);
            content.append(heading);

            if (message.lines.length) {
                _.each(message.lines, function (line) {
                    content.append($('<p>').html(this.formatter.render(line)));
                }, this);
            } else {
                content.append($('<p class="noData">').text('No IRCOPS'));
            }
            var overlay = new Overlay(content);
            return overlay;
        },
        ban_list: function (message) {
            var headers = [{
                mask: 'mask',
                title: 'Ban mask'
            }, {
                mask: 'usermask',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }];
            var channel = this.model.connection.findChannel(message.channel);
            if (channel && channel.userMember && channel.userMember.isMod()) {
                headers.push({
                    title: 'Remove',
                    format: _.bind(function (item) {
                        return this.formatter.linker.make('x', {
                            href: "",
                            'class': 'unban',
                            'title': 'Unban ' + item.mask,
                            'data-mask': item.mask
                        });
                    }, this)
                });
            }
            var table = this.buildTable(message, 'Ban list for ' + this.formatter.linkChannel(message.channel), message.bans, headers, 'No bans in effect');
            
            var overlay = new Overlay(table);
            
            table.on('click', 'a.unban', _.bind(function (e) {
                e.preventDefault();
                var link = $(e.currentTarget);
                this.model.connection.channelUnban(message.channel, link.attr('data-mask'), _.bind(function (response) {
                    if (response.success) {
                        this.model.connection.channelBanList(message.channel);
                    }
                }, this));
            }, this));
            
            return overlay;
        },
        modules_list: function (message) {
            var table = this.buildTable(message, 'Modules list for ' + this.formatter.render(this.model.connection.getFullLabel()), message.modules, false, 'No modules loaded');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        ban_exception_list: function (message) {
            var table = this.buildTable(message, 'Ban exception list for ' + this.formatter.linkChannel(message.channel), message.exceptions, [{
                mask: 'mask',
                title: 'Exception mask'
            }, {
                mask: 'usermask',
                title: 'Set by'
            }, {
                title: 'When',
                format: _.bind(function (data) {
                    return this.formatter.howLong(new Date(data.time * 1000));
                }, this)
            }, {
                title: 'Remove',
                format: _.bind(function (item) {
                    return this.formatter.linker.make('x', {
                        href: "",
                        'class': 'unexcept',
                        'title': 'Remove ban exception ' + item.mask,
                        'data-mask': item.mask
                    });
                }, this)
            }], 'No ban exceptions in effect');
            
            var overlay = new Overlay(table);
            
            table.on('click', 'a.unexcept', _.bind(function (e) {
                e.preventDefault();
                var link = $(e.currentTarget);
                this.model.connection.channelUnexcept(message.channel, link.attr('data-mask'), _.bind(function (response) {
                    if (response.success) {
                        this.model.connection.channelExceptList(message.channel);
                    }
                }, this));
            }, this));
            
            return overlay;
        },
        accept_list: function (message) {
            var table = this.buildTable(message, 'Accept list', message.nicks, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Nick'
            }], 'No accepted nicks');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        map_list: function (message) {
            return new Overlay(this.buildTable(message, this.formatter.render(this.model.connection.getFullLabel()), message.servers, [{
                format: _.bind(function (server) {
                    return this.formatter.render(server);
                }, this),
                title: 'Server map'
            }], 'No servers mapped'));
        },
        silence_list: function (message) {
            var table = this.buildTable(message, "Silence list for " + this.formatter.linkNick(message.nick), message.usermasks, [{
                format: _.bind(function (mask) {
                    return this.formatter.renderNoEmoji(mask);
                }, this),
                title: 'Patterns'
            }], 'Empty silence list');
            
            var overlay = new Overlay(table);
            
            return overlay;
        },
        rules_response: function (message) {
            var title = message.start || "Server rules for " + (message.server || message.from);
            var content = $('<div>');
            var heading = $('<div class="heading">');
            content.append($('<h2>').html(this.formatter.render(title)));
            if (message.lines.length) {
                _.each(message.lines, function (line) {
                    content.append($('<p>').html(this.formatter.render(line)));
                }, this);
            } else {
                content.append($('<p class="noData">').text('Server rules missing'));
            }
            var overlay = new Overlay(content);
            return overlay;
        },
        links_response: function (message) {
            var title = "Servers linked to " + this.formatter.render(message.server);
            if (message.mask && message.mask !== '*') {
                title += ' matching <b>' + this.formatter.renderNoEmoji(message.mask) + '</b>';
            }
            return new Overlay(this.buildTable(message, title, message.links, [{
                name: 'server',
                title: 'Server'
            }, {
                name: 'info',
                title: 'Info'
            }, {
                name: 'hopcount',
                title: 'Hops'
            }], 'No servers linked'));
        },
        chanfilter_list: function (message) {
            var title = "Channel filter patterns for " + this.formatter.linkChannel(message.channel);
            return new Overlay(this.buildTable(message, title, message.list, [{
                name: 'pattern',
                title: 'Pattern'
            }, {
                name: 'author',
                title: 'Set by'
            }, {
                name: 'time',
                title: 'When',
                format: _.bind(function (data) {
                    if (data.time && data.time > 0) {
                        return this.formatter.howLong(new Date(data.time * 1000));
                    }
                }, this)
            }], 'No channel filter patterns'));
        },
        query_too_long: function (message) {
            return new Overlay(this.formatter.renderNoEmoji(message.mask) + ': ' + this.formatter.render(message.msg));
        },
        input_too_long: function (message) {
            return new Overlay(this.formatter.render(message.msg));
        },
        try_again: function (message) {
            return new Overlay(this.formatter.render(message.command) + ': ' + this.formatter.render(message.msg));
        },
        list_response_fetching: function (message) {
            return new Overlay('Loading channel list for ' + this.formatter.render(message.server) + '…');
        },
        list_response_toomany: function (message) {
            var elistHint = '';
            var elist = this.model.connection.getISupport('ELIST');
            if (elist.indexOf('U') > -1) {
                elistHint = ' Try limiting the list to only respond with channels that have more than e.g. 50 members: /LIST >50.';
            }
            var linkHint = '';
            var netname = this.model.connection.getISupport('NETWORK');
            if (
                netname &&
                !this.model.connection.isTeamServer() &&
                !this.model.connection.isSlack() &&
                !this.model.connection.isTwitch()
            ) {
                var netsplitLink = this.formatter.linker.make('irc.netsplit.de', {
                    href: 'https://netsplit.de/channels/?net=' + netname,
                    rel: 'noreferrer',
                    target: '_blank'
                });
                linkHint = ' Look up channels on ' + netsplitLink;
            }
            return new Overlay('Too many channels to list for ' + this.formatter.render(message.server) + elistHint + linkHint);
        },
        list_response: function (message) {
            return new Overlay(this.buildTable(message, 'List of channels on ' + this.formatter.render(message.server), message.channels, [{
                name: 'name',
                title: 'Channels&nbsp;(' + this.formatter.render(message.num) + ')',
                channel: 'name'
            }, {
                title: 'Topic',
                format: _.bind(function (data) {
                    return this.formatter.renderLinkify(data.topic);
                }, this)
            }, {
                name: 'num_members',
                title: 'Members'
            }]));
        },
        isupport_list: function (message) {
            var table = this.buildIsupportTable(message.params);
            var head = "ISUPPORT parameters on " + this.formatter.linkConnection();
            return new Overlay(table, {
                head: head
            });
        },
        remote_isupport_params: function (message) {
            var table = this.buildIsupportTable(message.params);
            var head = "ISUPPORT parameters on <b>" + this.formatter.render(message.server) + '</b>';
            return new Overlay(table, {
                head: head
            });
        },
        names_reply: function (message) {
            return new Overlay(this.buildTable(message, 'Members of ' + this.formatter.linkChannel(message.chan), message.members, [{
                name: 'nick',
                title: 'Nickname',
                nick: 'nick'
            }, {
                name: 'mode',
                title: 'Mode'
            }]));
        },
        notice: function (message) {
            if (message.self) {
                return null;
            }
            if (this.model.isSelected()) {
                return null;
            }
            if (this.model.isServerLog()) {
                if ('server' in message) {
                    // Server notices (with no discernable sender) shouldn't overlay
                    // e.g. *** Looking up your hostname...
                    // see Message#isImportant
                    // We make an exception for throttle messages
                    var chan = Message.checkThrottleChan(message.msg);
                    if (chan) {
                        // ok
                    } else {
                        return null;
                    }
                }
                if (message.to_buffer) {
                    // Extra server notices from buffers. The pm notice will
                    // already make an overlay for this
                    return null;
                }
            }
            if (message.to_chan) {
                // Channel notices shouldn't overlay
                return null;
            }
            var connectionLabel = ' (' + this.formatter.render(this.model.connection.getName()) + ')';
            var target;
            if (message.from_host && message.from_name) {
                // Notice came from a connected user
                if (this.model.isChannel()) {
                    // Targetted to a channel
                    target  = this.formatter.link();
                    target += ' from ' + this.formatter.linkNick(message.from);
                } else {
                    // Targetted to you directly
                    target = this.formatter.linkNick(message.from);
                }
                target += connectionLabel;
            } else {
                // Notice came from the server
                if (this.model.isServerLog()) {
                    target = this.formatter.linkConnection();
                } else {
                    target = this.formatter.link();
                    // Not a server notice, so add the connection label
                    target += connectionLabel;
                }
            }
            var content = this.formatter.renderLinkify(message.msg);
            var head = "Notice: " + target;
            return new Overlay(content, {
                head: head,
                timeout: 5000,
                doneText: 'Close',
                keepFocus: true
            });
        },
        services_down: function (message) {
            var content = this.formatter.render(message.services_name) + ': ' + this.formatter.renderLinkify(message.msg);
            var head = "Notice on " + this.formatter.render(this.model.connection.getFullLabel());
            return new Overlay(content, {
                head: head
            });
        },
        time: function (message) {
            var content = this.formatter.render(message.time_string) + ' — <b>' + this.formatter.render(message.time_server) + '</b>';
            
            var head = "Time on " + this.formatter.render(this.model.connection.getFullLabel());
            return new Overlay(content, {
                head: head
            });
        },
        ison: function (message) {
            return new Overlay(this.buildTable(message, 'ISON results for ' + this.formatter.render(this.model.connection.getFullLabel()), message.nicks, [{
                format: _.bind(function (nick) {
                    return this.formatter.linkNick(nick);
                }, this),
                title: 'Active nicks'
            }], 'No active nick results'));
        },
        trace_response: function (message) {
            return new Overlay(this.buildTable(message, 'Trace for <b>' + this.formatter.render(message.query) + '</b>', message.trace, [{
                format: _.bind(function (trace) {
                    return this.formatter.render(trace);
                }, this),
                title: 'Results'
            }], 'No results'));
        },
        monitor_offline: function (message) {
            var content = this.buildTable(message, null, message.targets, [{
                format: _.bind(function (target) {
                    var targetUser = this.model.connection.makeUserFromTarget(
                        this.model.bid(),
                        target
                    );
                    return this.formatter.linkUser(targetUser);
                }, this),
                title: 'Offline'
            }]);
            var head = "Monitor status " + this.formatter.render(this.model.connection.getFullLabel());
            
            return new Overlay(content, {
                head: head,
                timeout: 5000,
                doneText: 'Close',
                keepFocus: true
            });
        },
        monitor_online: function (message) {
            var content = this.buildTable(message, null, message.targets, [{
                format: _.bind(function (target) {
                    var targetUser = this.model.connection.makeUserFromTarget(
                        this.model.bid(),
                        target
                    );
                    return this.formatter.linkUser(targetUser);
                }, this),
                title: 'Online'
            }]);
            var head = "Monitor status " + this.formatter.render(this.model.connection.getFullLabel());
            
            return new Overlay(content, {
                head: head,
                timeout: 5000,
                doneText: 'Close',
                keepFocus: true
            });
        },
        watch_status: function (message) {
            var content, timeout, keepFocus;
            if (message.stat) {
                content = this.formatter.renderLinkify(message.stat);
            } else if (message.nicks) {
                content = this.buildTable(message, null, message.nicks, [{
                    format: _.bind(function (nick) {
                        return this.formatter.linkNick(nick);
                    }, this),
                    title: 'Watching'
                }], 'Not watching any nicks');
            } else if (message.watch_nick) {
                // Notification about someone in the watch list, these timeout
                content = this.formatter.linkNick(message.watch_nick) + ' ' + this.formatter.renderLinkify(message.msg) + ' (' + this.formatter.render(message.username + '@' + message.userhost) + ')';
                timeout = 5000;
                keepFocus = true;
            } else {
                content = this.formatter.renderLinkify(message.msg);
            }
            var head = "Watch list status on " + this.formatter.render(this.model.connection.getFullLabel());
            
            return new Overlay(content, {
                head: head,
                timeout: timeout,
                doneText: 'Close',
                keepFocus: keepFocus
            });
        },
        channel_query: function (message) {
            var content;
            switch (message.query_type) {
            case 'timestamp':
                if (message.timestamp > 0) {
                    var createdDate = new Date(message.timestamp * 1000);
                    content = this.formatter.linkChannel(message.channel) + ' created on <b>' + createdDate.formatFullDate() + '</b>';
                }
                break;
            case 'mode':
                content = this.formatter.linkChannel(message.channel) + ' ';
                if (message.newmode) {
                    content += 'mode is <b>+' + this.formatter.render(message.newmode) + '</b>';
                } else {
                    content += 'no channel mode';
                }
                break;
            case 'url':
                content = this.formatter.linkChannel(message.channel) + ' homepage: ' + this.formatter.renderLinkify(message.url);
                break;
            }
            if (content) {
                return new Overlay(content, {
                    doneText: 'Close',
                });
            }
        },
        userhost: function (message) {
            return new Overlay(this.buildTable(message, 'USERHOST results for ' + this.formatter.render(this.model.connection.getFullLabel()), message.users, [{
                format: _.bind(function (data) {
                    var className;
                    var title = data.nick;
                    if (data.away) {
                        title += ' (away)';
                        className = 'away';
                    }
                    return this.formatter.linkNick(data.nick, {
                        className: className,
                        title: title
                    });
                }, this),
                title: 'Active nicks'
            }, {
                name: 'userhost',
                title: 'Userhost'
            }, {
                name: 'oper',
                title: 'Oper'
            }], 'No active nick results'));
        },
        channel_invite: function (message) {
            if (this.model.isServerLog() && (message.to_chan || message.to_buffer)) {
                // Extra server invites. The pm invite will
                // already make an overlay for this
                return null;
            }
            var channelLink = this.formatter.linkChannel(message.channel, {
                className: 'channelInviteLink'
            });
            var content = this.formatter.linkNick(message.from) + " is inviting you to join " + channelLink;
            var head = "Channel invite on " + this.formatter.linkConnection();
            return new Overlay(content, {
                head: head,
                timeout: 5000
            });
        }
    }
});

module.exports = BufferOverlayHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferoverlayhandler.js
// module id = C3KD
// module chunks = 1